import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { ContestRegistration } from "./hooks/useContestData";
import { SortConfig } from "../hooks/useSortData";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

interface ContestTableProps {
  registrations: ContestRegistration[];
  sortConfig: SortConfig<ContestRegistration> | null;
  onSort: (key: keyof ContestRegistration) => void;
}

export const ContestTable = ({ registrations, sortConfig, onSort }: ContestTableProps) => {
  const getSortIcon = (key: keyof ContestRegistration) => {
    if (!sortConfig || sortConfig.key !== key) {
      return <ArrowUpDown className="h-4 w-4 ml-1" />;
    }
    return sortConfig.direction === "asc" ? (
      <ArrowUp className="h-4 w-4 ml-1" />
    ) : (
      <ArrowDown className="h-4 w-4 ml-1" />
    );
  };

  const SortableHeader = ({
    column,
    label,
  }: {
    column: keyof ContestRegistration;
    label: string;
  }) => (
    <TableHead
      className="cursor-pointer hover:bg-muted/50"
      onClick={() => onSort(column)}
    >
      <div className="flex items-center">
        {label}
        {getSortIcon(column)}
      </div>
    </TableHead>
  );

  const formatCategory = (category: string) => {
    switch (category) {
      case "college":
        return "Collège";
      case "lycee":
        return "Lycée";
      default:
        return category;
    }
  };

  return (
    <div className="rounded-md border overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <SortableHeader column="created_at" label="Date" />
            <SortableHeader column="category" label="Catégorie" />
            <SortableHeader column="class_name" label="Classe" />
            <SortableHeader column="class_level" label="Niveau" />
            <SortableHeader column="school_name" label="Établissement" />
            <SortableHeader column="school_city" label="Ville" />
            <SortableHeader column="academy" label="Académie" />
            <SortableHeader column="teacher_name" label="Enseignant" />
            <TableHead>Email enseignant</TableHead>
            <SortableHeader column="participants_count" label="Participants" />
            <SortableHeader column="total_students_count" label="Effectif classe" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {registrations.map((reg) => (
            <TableRow key={reg.id}>
              <TableCell>
                {format(new Date(reg.created_at), "dd/MM/yyyy", { locale: fr })}
              </TableCell>
              <TableCell>{formatCategory(reg.category)}</TableCell>
              <TableCell>{reg.class_name || "-"}</TableCell>
              <TableCell>{reg.class_level}</TableCell>
              <TableCell>{reg.school_name}</TableCell>
              <TableCell>{reg.school_city}</TableCell>
              <TableCell>{reg.academy}</TableCell>
              <TableCell>{reg.teacher_name}</TableCell>
              <TableCell>{reg.teacher_email}</TableCell>
              <TableCell className="text-center">{reg.participants_count}</TableCell>
              <TableCell className="text-center">{reg.total_students_count}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
